/* MC — Compteurs animés au scroll (code original) */
if (!customElements.get('mc-stats')) {
  customElements.define(
    'mc-stats',
    class MCStats extends HTMLElement {
      connectedCallback() {
        this.values = Array.from(this.querySelectorAll('[data-count]'));
        if (!this.values.length) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.values.forEach((el) => (el.textContent = el.dataset.count));
          return;
        }
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.values.forEach((el) => this.animate(el));
                this.observer.disconnect();
              }
            });
          },
          { threshold: 0.4 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      animate(el) {
        const target = parseInt(el.dataset.count, 10);
        if (Number.isNaN(target)) {
          el.textContent = el.dataset.count;
          return;
        }
        const duration = 1400;
        const start = performance.now();
        const step = (now) => {
          const t = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - t, 3);
          el.textContent = Math.round(target * eased);
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }
    }
  );
}
